module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_appleQRcode.45ef95c3.png";